/**
 * Created by andreyna on 6/13/2016.
 */
import BaseModelComponent from '../../../base/base_model_component';

class BaseOptionsModel extends BaseModelComponent {

    _options = {};

    /**
     * get application settings options
     * Object contains of 'reminder property'
     * @returns {object}
     */
    getOptions() {
        return this._options;
    }

    /**
     * set / update selected object in the model
     *
     * @param {string} value
     * @returns {bool}
     */
    setOptions(options) {

    }
}

export default BaseOptionsModel

